// userSlice.js

import { createSlice } from "@reduxjs/toolkit";

// Retrieve user data from local storage (if available)
const persistedUserString = localStorage.getItem("user");
const persistedUser = persistedUserString
  ? JSON.parse(persistedUserString)
  : null;

const initialState = {
  user: persistedUser?.user || null, // Ensure this is correctly retrieved
  isAuthenticated: Boolean(persistedUser),
  email: persistedUser?.email || null,
  userName: persistedUser?.userName || null,
  id: persistedUser?.id || null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    login(state: any, action: any) {
      const { user, email, userName, id } = action.payload;
      state.user = user;
      state.isAuthenticated = true;
      state.email = email;
      state.userName = userName;
      state.id = id;
      // Save user data in local storage
      localStorage.setItem("user", JSON.stringify(action.payload));
    },
    logout(state: any) {
      state.user = null;
      state.isAuthenticated = false;
      state.email = null;
      state.userName = null;
      state.id = null;
      // Remove user data from local storage
      localStorage.removeItem("user");
    },
  },
});

export const { login, logout } = userSlice.actions;
export default userSlice.reducer;
